<template>
  <div>
    <template>
      <v-toolbar flat>
        <v-toolbar-title>Motores</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn
          color="primary"
          dark
          height="40"
          v-if="hadPermission(3, 2)"
          @click="controller.openForm(null)"
        >
          <v-icon left>mdi-plus</v-icon> Novo
        </v-btn>

        <v-menu :close-on-click="false" :close-on-content-click="false" :nudge-width="300" offset-x></v-menu>
      </v-toolbar>
    </template>

    <v-data-table
      class="elevation-2 ma-2"
      dense
      height="85vh"
      fixed-header
      :headers="headers"
      :items="controller.enginePagination.items"
      :loading="controller.loading"
      :server-items-length="controller.enginePagination.total"
      :options.sync="controller.options"
      :footer-props="{
        'items-per-page-options': [40, 80],
      }"
    >

      <template v-slot:[`item.power`]="{ item }">
        <p>{{ item.power }}</p>
      </template>

      <template v-slot:[`item.nominal_voltage`]="{ item }">
        <p>{{ item.nominal_voltage || '--' }}</p>
      </template>

      <template v-slot:[`item.nominal_current`]="{ item }">
        <p>{{ item.nominal_current || '--' }}</p>
      </template>

      <template v-slot:[`item.startingMethodString`]="{ item }">
        <p>{{ item.startingMethodString || '--' }}</p>
      </template>

      <template v-slot:[`item.in_use`]="{ item }">
        <v-icon v-if="item.in_use" color="green">mdi-check-circle-outline</v-icon>
        <v-icon v-else color="red">mdi-close-circle-outline</v-icon>
      </template>

      <template v-slot:[`item.in_use_set`]="{ item }">
        <v-icon v-if="item.in_use_set" color="green">mdi-check-circle-outline</v-icon>
        <v-icon v-else color="red">mdi-close-circle-outline</v-icon>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <v-col cols="3">
            <!-- <v-btn icon class="px-2">
              <v-icon small color="orange">mdi-database</v-icon>
            </v-btn> -->
          </v-col>

          <v-col cols="3">
            <v-btn
              v-if="hadPermission(3, 3)"
              @click="controller.openForm(item)"
              icon
              class="px-2"
            >
              <v-icon small color="blue">mdi-pencil</v-icon>
            </v-btn>  
          </v-col>
          
          <v-col cols="3">
            <v-btn v-if="hadPermission(3, 4)" @click="controller.delete(item)" icon class="px-2">
            <v-icon small color="red">mdi-delete</v-icon>
          </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <v-dialog v-model="controller.showForm" scrollable max-width="500px" @click:outside="controller.closeForm()">
      <v-card v-if="controller.engine">
        <div class="primary d-flex justify-center mb-3">
          <v-card-title style="color: white" v-if="controller.engine.id">
            Editar Motor
          </v-card-title>
          <v-card-title style="color: white" v-else>
            Adicionar novo Motor
          </v-card-title>
        </div>

        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-text-field
              filled
              required
              :rules="[nameRules]"
              v-model="controller.engine.name"
              label="Nome"
            />
            <v-text-field filled v-model="controller.engine.brand" label="Marca"/>
            <v-text-field filled v-model="controller.engine.model" label="Modelo"/>
            <v-text-field filled type="number" v-model.number="controller.engine.power"  label="Potencia"/>
            <v-text-field filled type="number" v-model.number="controller.engine.nominalVoltage"  label="Voltagem"/>
            <v-text-field filled type="number" v-model.number="controller.engine.nominalCurrent" label="Corrente"/>
            <v-text-field filled v-model="controller.engine.startingMethodString" label="Metodo de inicialização"/>
            <v-text-field filled type="number" v-model.number="controller.engine.efficiency" label="Eficiencia"/>
            <v-text-field filled type="number" v-model.number="controller.engine.nominalRotation" label="Rotação"/>

            <v-autocomplete
              :disabled="!!controller.engine.id"
              :items="controller.placePagination.items"
              :rules="[placeRules]"
              :search-input.sync="controller.searchPlace"
              color="primary"
              dense
              filled
              item-text="name"
              item-value="id"
              label="Local"
              required
              v-model="controller.engine.place_id"
            />
            <v-autocomplete
              :disabled="!!controller.engine.id"
              :items="controller.companyPagination.items"
              :rules="[companyRules]"
              :search-input.sync="controller.searchCompany"
              color="primary"
              dense
              filled
              item-text="name"
              item-value="id"
              label="Empresa"
              required
              v-model="controller.engine.company_id"
            />
          </v-form>
        </v-card-text>

        <v-card-actions class="px-6">
          <v-btn @click="controller.closeForm()" outlined color="red">
            <v-icon left>mdi-delete</v-icon>cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="controller.save()" color="primary">
            <v-icon left>mdi-content-save</v-icon>salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { engineController } from "@/di/di";
import _ from "lodash";

export default {
  data: (context) => ({
    valid: true,
    controller: engineController(context),
    search: '',
    headers: [
      {
        text: 'ID',
        align: 'start',
        sortable: true,
        value: 'id',
      },
      {
        text: 'Nome',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Levante',
        align: 'start',
        sortable: true,
        value: 'place_id',
      },
      {
        text: 'Companhia',
        align: 'start',
        sortable: true,
        value: 'company_id',
      },
      {
        text: 'Marca',
        align: 'start',
        sortable: false,
        value: 'brand',
      },
      {
        text: 'Modelo',
        align: 'start',
        sortable: false,
        value: 'model',
      },
      {
        text: 'Potência',
        align: 'start',
        sortable: false,
        value: 'power',
      },
      {
        text: 'Tensão Nominal',
        align: 'start',
        sortable: false,
        value: 'nominalVoltage',
      },
      {
        text: 'Corrente Nominal',
        align: 'start',
        sortable: false,
        value: 'nominalCurrent',
      },
      {
        text: 'Starting Method',
        align: 'start',
        sortable: false,
        value: 'startingMethodString',
      },
      {
        text: 'Em uso',
        align: 'start',
        sortable: false,
        value: 'in_use',
      },
      {
        text: 'Em uso (Conjunto)',
        align: 'start',
        sortable: false,
        value: 'in_use_set',
      },
      {
        text: 'Ações',
        align: 'start',
        sortable: false,
        value: 'actions',
      },
    ]
  }),
  computed: {
    computedPlace() {
      return (id) => this.places.find(place => place.id === id)
    },
    computedCompany() {
      return (id) => this.companies.find(company => company.id === id)
    }
  },
  async mounted() {
    this.controller.paginate();
    this.controller.paginateCompany()
    this.controller.paginatePlace()
  },
  methods: {
    nominalVoltageRules(v) {
      return v !== "" || "Insira um número válido"
    },
    nameRules(v) {
      return !!v || "Nome é obrigatório"
    },
    placeRules(v) {
      return !!v || "Local é obrigatório"
    },
    companyRules(v) {
      return !!v || "Empresa é obrigatório"
    }
  },
  watch: {
    "controller.options": {
      handler() {
        this.controller.watchOptions();
      },
      deep: true
    },
    "controller.searchCompany": _.debounce(function () {
      this.controller.watchSearchCompany();
    }, 500),
    "controller.searchPlace": _.debounce(function () {
      this.controller.watchSearchPlace();
    }, 500),
  }
}
</script>

<style scoped>
.card {
  display: flex;
  font-display: column;
}
</style>
